import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UserStorage } from '@tv3/services/utils/storage.service'
import { FormControl, FormGroup } from '@angular/forms'
import { delay } from 'rxjs/operators'
import { FilterGroup } from '@tv3/services/utils/filters.service'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-table-search',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.scss'],
})
export class TableSearchComponent extends Destroyable implements OnInit {
  @Input() filterGroup: FilterGroup
  @Input() filterControl: FormGroup
  @Input() hideClearFilterBtn = false

  @Input() inputTooltip = ''
  @Input() inputPlaceholder = 'Search here...'

  @Output() search = new EventEmitter<string>()
  @Output() clearFilters = new EventEmitter()

  searchCtrl = new FormControl('')

  constructor(private storage: UserStorage) {
    super()
  }

  ngOnInit() {
    if (this.filterGroup) {
      const storageKey = `SEARCH::${this.filterGroup}`
      const initialTerm = this.storage.get(storageKey, '')

      this.searchCtrl.patchValue(initialTerm)

      this.search.pipe(delay(250), untilDestroy(this)).subscribe((term) => {
        this.storage.set(storageKey, term)
      })

      this.onSearch(initialTerm)
    }

    this.searchCtrl.valueChanges.pipe(untilDestroy(this)).subscribe((value) => {
      this.search.emit(value)
    })
  }

  onSearch(term: string) {
    this.search.emit(term)
  }

  onClearSearch() {
    this.search.emit('')
    this.searchCtrl.patchValue('')
  }

  onClearFilters() {
    this.onClearSearch()
    this.clearFilters.emit(true)
  }
}
